import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { BehaviorSubject } from 'rxjs';

import * as XLSX from 'xlsx';
import * as jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { BasemodelService } from '../basemodel.service';

@Injectable({
  providedIn: 'root'
})
export class CampuscctvserviceService {
  CctvDetails: any;
  private token = '';
  environment: any;

  constructor(public http: HttpClient, private base: BasemodelService) { }
  private refreshToken = environment.printasseturl + "/employee/login/v2/api/refreshToken"
  public search = new BehaviorSubject<string>("");

  getHomeData() {
    const headers = { "content-Type": "application/json", 'Access-control-Allow-Origin': '*' }
    return this.http.get<any>(environment.cctvURL + '/ses/cctv/status',)
  }
  getCampusData(campusId: any) {
    return this.http.get<any>(environment.cctvURL + '/ses/cctv/campusCctvDetails?campusId=' + campusId,)
  }
  getBuildingData(buildingId: any) {
    return this.http.get<any>(environment.cctvURL + '/ses/cctv/buildingCctvDetails?buildingId=' + buildingId,)
  }
  getCctvCampus(cctvcampusId: any) {
    return this.http.get<any>(environment.cctvURL + '/ses/cctv/dvrDetails?cctvDetId=' + cctvcampusId,)
  }
  getChannel(cctvDetId: any, channelId: any) {
    return this.http.get<any>(environment.cctvURL + '/ses/cctv/dvrDetails?cctvDetId=' + cctvDetId + '&channelsNo=' + channelId)
  }
  getOverAllCities() {
    return this.http.get<any>(environment.cctvURL + '/ses/cctv/overallCities',)
  }
  // postCctvDetails(payload:any){
  //   return this.http.post<any>('http://43.205.237.13:8180/building_cctv_frame', payload)
  // } 

  // Here we click filter list below connected details

  getconnceted() {
    return this.http.get<any>(environment.cctvURL + '/ses/cctv/overallConnected')
  }
  getnotconnceted() {
    return this.http.get<any>(environment.cctvURL + '/ses/cctv/overallNotConnected')
  }
  getstreaming() {
    return this.http.get<any>(environment.cctvURL + '/ses/cctv/overallStreaming')
  }
  getnotstreaming() {
    return this.http.get<any>(environment.cctvURL + '/ses/cctv/overallNotStreaming')
  }


  // dashboard DVR status //

  getdashboarddvr() {
    return this.http.get<any>(environment.cctvURL + '/ses/cctv/dashboardDvrDetails')
  }

  gettotaldvr() {
    return this.http.get<any>(environment.cctvURL + '/ses/cctv/overallDvrDetails')
  }

  getdvrconnected() {
    return this.http.get<any>(environment.cctvURL + '/ses/cctv/overallConnectedDvrDetails')
  }

  getdvtnotconnected() {
    return this.http.get<any>(environment.cctvURL + '/ses/cctv/overallNotConnectedDvrDetails')
  }

  //===  dashboard cctv camera status ===//

  getcctvcamera(selected_value: any) {
    return this.http.get<any>(environment.cctvURL + '/ses/cctv/overallCctvConnected?filterBy=' + selected_value)
  }
  getcctvnotconnect(selected_value: any) {
    return this.http.get<any>(environment.cctvURL + '/ses/cctv/overallCctvNotConnected?filterBy=' + selected_value)
  }
  getcctvstreaming(selected_value: any) {
    return this.http.get<any>(environment.cctvURL + '/ses/cctv/overallCctvStreaming?filterBy=' + selected_value)
  }
  getcctvnotstreaming(selected_value: any) {
    return this.http.get<any>(environment.cctvURL + '/ses/cctv/overallCctvNotStreaming?filterBy=' + selected_value)
  }

  getcctvnovideo(selected_value: any) {
    return this.http.get<any>(environment.cctvURL + '/ses/cctv/overallCctvNoVideoStreaming?filterBy=' + selected_value)
  }
  //==== dashboard cctv camera status right click ====/

  getconnectedstateright(state: any, id: any) {
    return this.http.get<any>(environment.cctvURL + '/ses/cctv/connected?filterBy=' + state + '&id=' + id)
  }

  getnotconnectedright(state: any, id: any) {
    return this.http.get<any>(environment.cctvURL + '/ses/cctv/notconnected?filterBy=' + state + '&id=' + id)
  }

  getstreamingright(state: any, id: any) {
    return this.http.get<any>(environment.cctvURL + '/ses/cctv/streaming?filterBy=' + state + '&id=' + id)
  }

  getnotstreamingright(state: any, id: any) {
    return this.http.get<any>(environment.cctvURL + '/ses/cctv/Notstreaming?filterBy=' + state + '&id=' + id)
  }

  getnovideoright(state: any, id: any) {
    return this.http.get<any>(environment.cctvURL + '/ses/cctv/NoVideo?filterBy=' + state + '&id=' + id)
  }

  //  card and dvr details //

  // getcctvdetail(cctvDetdId: any){
  //   return this.http.get<any>(environment.apiUrl + '/ses/cctv/viewAll?cctvDetId=' + cctvDetdId,)
  // }

  viewall(cctvDetId: any,) {
    return this.http.get<any>(environment.cctvURL + '/ses/cctv/viewAll?cctvDetId=' + cctvDetId,)
  }



  // excel and pdf data //

  exportToExcel(table: HTMLTableElement, fileName: string) {
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(table);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, `${fileName}.xlsx`);
  }

  // generatePdf(htmlContent: HTMLElement, fileName: string) {
  //   html2canvas(htmlContent).then((canvas) => {
  //     // const pdf = new jsPDF();
  //     const pdf = new jsPDF.default();
  //     const imgData = canvas.toDataURL('image/png');
  //     const imgProps = pdf.getImageProperties(imgData);
  //     const pdfWidth = pdf.internal.pageSize.getWidth();
  //     const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
  //     pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
  //     pdf.save(fileName);
  //   });
  // }


  getcctvdetails(cctvDetId: any) {
    const headers = new HttpHeaders({
      'Authorization': `${this.token}`
    });
    return this.http.get(environment.cctvURL + '/ses/cctv/getCctvDetailsInDvrNvr', { headers, params: { cctvDetId } })
  }

  postcctvdetails(payload: any) {
    const headers = new HttpHeaders({
      'Authorization': `${this.token}`
    });
    return this.http.post(environment.cctvURL + '/ses/cctv/updateCctvDetailsInDvrNvr', payload, { headers })
  }

  getpwddetails(password: any) {
    const headers = new HttpHeaders({
      'Authorization': `${this.token}`
    });
    return this.http.get(environment.cctvURL + '/ses/cctv/pwdDecrypt', { headers, params: { password } })
  }

  getRefreshToken() {
    const userId = localStorage.getItem("userId");
    const refreshKey = localStorage.getItem("tokenRefreshKey");
    const deviceSessionId = localStorage.getItem("deviceSessionId");
    const payload = {
      "userId": userId,
      "refreshKey": refreshKey,
      "deviceSessionId": deviceSessionId
    }
    console.log(payload)
    const headers = {};
    return this.http.post(environment.printasseturl + '/employee/login/v2/api/refreshToken', payload, { headers });
  }

  //NEW FUTURE TOTAL DVR TABLE //
  getTableBusniessType(businessType: any) {
    const headers = new HttpHeaders({
      'Authorization': `${this.token}`
    });
    return this.http.get(environment.cctvURL + '/ses/cctv/states?businessType=' + businessType, { headers })
  }

  postDvrList(payload:any) {
    const headers = new HttpHeaders({
      'Authorization': `${this.token}`
    });
    return this.http.post(environment.cctvURL + '/ses/cctv/dvrList', payload, { headers })
  }

  //NEW FUTURE TOTAL DVR TABLE //

}
